import { render, staticRenderFns } from "./DecorEditor.vue?vue&type=template&id=070e6e78&scoped=true"
import script from "./DecorEditor.vue?vue&type=script&lang=js"
export * from "./DecorEditor.vue?vue&type=script&lang=js"
import style0 from "./DecorEditor.vue?vue&type=style&index=0&id=070e6e78&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070e6e78",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('070e6e78')) {
      api.createRecord('070e6e78', component.options)
    } else {
      api.reload('070e6e78', component.options)
    }
    module.hot.accept("./DecorEditor.vue?vue&type=template&id=070e6e78&scoped=true", function () {
      api.rerender('070e6e78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plugin/dining/decor/DecorEditor.vue"
export default component.exports